export const Phone = (props) => {
    const { name, phone, setPhone } = props;
    return (
        <div className="row">
            <label className="label" htmlFor={name}>{name}</label>
            <input type="tel" name={name} id={name} pattern="[0-9]{2}( [0-9][0-9]){4}" value={phone} onChange={(e) => { setPhone(e.target.value); }} />
        </div>
    )
}